import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TranscodeProgress_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null, media?: { __typename?: 'AudioMedia', duration?: number | null, fps?: number | null, id: string, insertedAt?: string | null, transcodedAt?: string | null, audioTranscodes?: Array<{ __typename?: 'AudioTranscodeInfo', key: string, encodeStatus: Types.EncodeStatusEnum }> | null } | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null, media?: { __typename?: 'DocumentMedia', id: string, insertedAt?: string | null, transcodedAt?: string | null, pageCount?: number | null, thumbScrubSprite?: { __typename?: 'ThumbScrubSheet', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | { __typename?: 'ThumbScrubStrip', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | null } | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null, media?: { __typename?: 'ImageMedia', id: string, insertedAt?: string | null, transcodedAt?: string | null, imageTranscodes?: Array<{ __typename?: 'ImageTranscodeInfo', encodeStatus: Types.EncodeStatusEnum, key: string }> | null } | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, media?: { __typename?: 'InteractiveMedia', id: string, insertedAt?: string | null, transcodedAt?: string | null, interactiveTranscodes?: Array<{ __typename?: 'InteractiveTranscodeInfo', encodeStatus: Types.EncodeStatusEnum, key: string }> | null } | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null, media?: { __typename?: 'ModelMedia', duration?: number | null, id: string, insertedAt?: string | null, transcodedAt?: string | null, metadata?: { __typename?: 'ModelMetadata', id?: string | null, originalHeight?: number | null, originalWidth?: number | null } | null, thumbScrubSprite?: { __typename?: 'ThumbScrubSheet', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | { __typename?: 'ThumbScrubStrip', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | null, modelTranscodes?: Array<{ __typename?: 'ModelTranscodeInfo', encodeStatus: Types.EncodeStatusEnum, key: string }> | null, videoTranscodes?: Array<{ __typename?: 'VideoTranscodeInfo', encodeStatus: Types.EncodeStatusEnum, key: string }> | null } | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null, media?: { __typename?: 'UnsupportedMedia', id: string, insertedAt?: string | null, transcodedAt?: string | null } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgress_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, insertedAt: string, status: Types.AssetStatusEnum, deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null, media?: { __typename?: 'VideoMedia', duration?: number | null, id: string, insertedAt?: string | null, transcodedAt?: string | null, metadata?: { __typename?: 'VideoMetadata', id?: string | null, originalHeight?: number | null, originalWidth?: number | null } | null, thumbScrubSprite?: { __typename?: 'ThumbScrubSheet', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | { __typename?: 'ThumbScrubStrip', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | null, videoTranscodes?: Array<{ __typename?: 'VideoTranscodeInfo', encodeStatus: Types.EncodeStatusEnum, key: string }> | null } | null, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null, fireflyGeneration?: { __typename?: 'FireflyGeneration', id: string, overallStatus: Types.FireflyOverallGenerationStatus, modelVersion?: { __typename?: 'FireflyModelVersion', id: string, displayName: string } | null } | null };

export type TranscodeProgressFragment = TranscodeProgress_AudioAsset_Fragment | TranscodeProgress_DocumentAsset_Fragment | TranscodeProgress_FileAsset_Fragment | TranscodeProgress_FolderAsset_Fragment | TranscodeProgress_ImageAsset_Fragment | TranscodeProgress_InteractiveAsset_Fragment | TranscodeProgress_InteractiveLiveAsset_Fragment | TranscodeProgress_ModelAsset_Fragment | TranscodeProgress_UnsupportedAsset_Fragment | TranscodeProgress_VersionStackAsset_Fragment | TranscodeProgress_VideoAsset_Fragment;

export const TranscodeProgress = /*#__PURE__*/ gql`
    fragment TranscodeProgress on Asset {
  id
  fireflyGeneration {
    id
    modelVersion {
      id
      displayName
    }
    overallStatus
  }
  insertedAt
  status
  ... on AudioAsset {
    deviceLink {
      id
    }
    media {
      duration
      fps
      id
      insertedAt
      transcodedAt
      audioTranscodes {
        key
        encodeStatus
      }
    }
    thumbnailImageUrl {
      url
    }
  }
  ... on DocumentAsset {
    deviceLink {
      id
    }
    media {
      id
      insertedAt
      transcodedAt
      pageCount
      thumbScrubSprite {
        frames
        streamUrl
        tileX
        tileY
      }
    }
    thumbnailImageUrl {
      url
    }
  }
  ... on ImageAsset {
    deviceLink {
      id
    }
    media {
      id
      insertedAt
      transcodedAt
      imageTranscodes {
        encodeStatus
        key
      }
    }
    thumbnailImageUrl {
      url
    }
  }
  ... on InteractiveAsset {
    media {
      id
      insertedAt
      transcodedAt
      interactiveTranscodes {
        encodeStatus
        key
      }
    }
    thumbnailImageUrl {
      url
    }
  }
  ... on UnsupportedAsset {
    deviceLink {
      id
    }
    media {
      id
      insertedAt
      transcodedAt
    }
  }
  ... on VideoAsset {
    deviceLink {
      id
    }
    media {
      duration
      id
      insertedAt
      metadata {
        id
        originalHeight
        originalWidth
      }
      transcodedAt
      thumbScrubSprite {
        frames
        streamUrl
        tileX
        tileY
      }
      videoTranscodes {
        encodeStatus
        key
      }
    }
    thumbnailImageUrl {
      url
    }
  }
  ... on ModelAsset {
    deviceLink {
      id
    }
    media {
      duration
      id
      insertedAt
      metadata {
        id
        originalHeight
        originalWidth
      }
      transcodedAt
      thumbScrubSprite {
        frames
        streamUrl
        tileX
        tileY
      }
      modelTranscodes {
        encodeStatus
        key
      }
      videoTranscodes {
        encodeStatus
        key
      }
    }
    thumbnailImageUrl {
      url
    }
  }
}
    ` as unknown as DocumentNode<TranscodeProgressFragment, unknown>;

        

        
export const useTranscodeProgressFragment = (
  input: string | Omit<UseFragmentOptions<TranscodeProgressFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<TranscodeProgressFragment>({
    fragment: TranscodeProgress,
    fragmentName: 'TranscodeProgress',
    ...options,
  });
};
  
        